import styled from 'styled-components';
import { isIE, isEdge } from '../../../common/utilities/browserDetection';

export const HeaderContainer = styled.div`
    border-bottom: 1px solid #E6EDF5;
    border-top: 1px solid #E6EDF5;
    color: #8e8e8e;
    display: flex;
    font-weight: 500;
    height: 25px;
    height: fit-content;
    margin-left: 10px;
    margin-top: 20px;
    padding-bottom: 15px;
    padding: ${() => (isIE() || isEdge()) ? `15px 0 40px 0;` : `15px 0;`}
    position: relative;
    text-align: left;
`;

export const headerColumns = {
    Name: styled.div`width: 12%;`,
    Warning: styled.div`width: 4%;`,
    Description: styled.div`width: 7%;`,
    RequestType: styled.div`width: 8%;`,
    ApprovalProcess: styled.div`width: 8%;`,
    SubmissionPeriod: styled.div`width: 14%;`,
    RequestPeriod: styled.div`width: 14%;`,
    CreatedBy: styled.div`width: 10%;`,
    People: styled.div`width: 9%;`,
    Setup: styled.div`width: 12%;`,
    pointer: { cursor: 'pointer' },
};
